module.exports = __webpack_public_path__ + "img/loyality_round_bg.7812417a.png";